import React from "react";
import { Col, Form, Row } from "react-bootstrap";

interface ActivityViewProps
{
    data: Activity;
}

export default class ActivityView extends React.Component<ActivityViewProps>
{
    render(): React.ReactNode 
    {
        return <Form>
            <Form.Group as={Row}>
                <Form.Label className="grayText" column md="5">
                    Varsity Athletics
                    </Form.Label>
                <Col md="7">
                    <Form.Control plaintext as={"div"}>
                        <b>{
                            this.props.data.varsityAthletics ? this.props.data.varsityAthletics : " - "
                        }</b>
                    </Form.Control>
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Label className="grayText" column md="5">
                    Greek Member
                    </Form.Label>
                <Col md="7">
                    <Form.Control plaintext as={"div"}>
                        <b>{this.props.data.greekMember ? this.props.data.greekMember : " - "}</b>
                    </Form.Control>
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Label className="grayText" column md="5">
                    ILG Member
                    </Form.Label>
                <Col md="7">
                    <Form.Control plaintext as={"div"}>
                        <b>{this.props.data.ilgMember ? this.props.data.ilgMember : " - "}</b>
                    </Form.Control>
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Label className="grayText" column md="5">
                    Student Activities
                    </Form.Label>
                <Col md="7">
                    <Form.Control plaintext as={"div"}>
                        <b>{this.props.data.studentActivities ? this.props.data.studentActivities.join(",") : " - "}</b>
                    </Form.Control>
                </Col>
            </Form.Group>
        </Form>;
    }
}